import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-pro';
import { dateFormatter } from 'utils/grid';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

export const useGetColumns = () => {
  const { t } = useTranslation('common');

  return useMemo(
    () =>
      [
        {
          field: 'validFrom',
          type: 'date',
          headerName: t('validFrom'),
          valueFormatter: dateFormatter,
          flex: 1,
          minWidth: 120
        },
        {
          field: 'validTo',
          type: 'date',
          headerName: t('validTo'),
          valueFormatter: dateFormatter,
          flex: 1,
          minWidth: 120
        },
        {
          field: 'maxNumberOfDays',
          type: 'number',
          headerName: t('dayLimitArrangements.maxNumberOfDays'),
          flex: 1,
          minWidth: 150,
          align: 'left',
          headerAlign: 'left'
        },
        {
          field: 'dayLimitArrangementNotApplicableForEmployee',
          type: 'boolean',
          headerName: t('dayLimitArrangements.notApplicable'),
          flex: 1,
          minWidth: 150,
          renderCell: (params) => <BooleanCell {...params} />
        },
        {
          field: 'periodDescription',
          type: 'string',
          headerName: t('dayLimitArrangements.periodDescription'),
          flex: 1,
          minWidth: 150
        }
      ] as GridColDef[],
    [t]
  );
};
